export default 'economy.layouts';